import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {BecasService} from '../../../services/becas/becas.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  activeBeca: any = null;
  search = '';
  constructor(private router: Router, private becasService: BecasService) { }

  ngOnInit(): void {
    this.getBecaActive();
  }
  onSearch(): void {
    setTimeout(() => this.router.navigate(['/busqueda', this.search]), 2500);
  }
  getBecaActive(): void {
    this.becasService.getBecaActive()
      .subscribe((res) => {
        this.activeBeca = res;
      });
  }

}
